import React, { useEffect, useState } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import MainLayout from './layouts/MainLayout';
import HomePage from './pages/HomePage';
import OurLocationsPage from './pages/OurLocationsPage';
import { initSmoothScroll } from './utils/smoothScroll';
import { initScrollAnimations } from './utils/animateOnScroll';
import './App.css';

// Simple fade animation component that doesn't rely on findDOMNode
const AnimatedRoutes = () => {
  const location = useLocation();
  const [displayLocation, setDisplayLocation] = useState(location);
  const [transitionStage, setTransitionStage] = useState("fadeIn");

  useEffect(() => {
    if (location.pathname !== displayLocation.pathname) {
      setTransitionStage("fadeOut");

      // Wait for animation to complete before changing the route
      const timeout = setTimeout(() => {
        setDisplayLocation(location);
        setTransitionStage("fadeIn");
      }, 300); // Slightly shorter than CSS animation time

      return () => clearTimeout(timeout);
    }
  }, [location, displayLocation]);

  return (
    <div className={`page-transition ${transitionStage}`}>
      <Routes location={displayLocation}>
        <Route path="/" element={<HomePage />} />
        <Route path="/our-locations" element={<OurLocationsPage />} />
        {/* Redirects for removed pages that are still indexed in Google */}
        <Route path="/airline-crew-transportation-near-me" element={<Navigate to="/" replace />} />
        <Route path="/servicios-de-transporte-de-tripulacion-aerea-en-san-francisco-oakland-san-jose-silicon-valley" element={<Navigate to="/" replace />} />
      </Routes>
    </div>
  );
};

function App() {
  const { i18n } = useTranslation();

  // Initialize language from localStorage on app mount
  useEffect(() => {
    const savedLanguage = localStorage.getItem('preferredLanguage');
    if (savedLanguage) {
      i18n.changeLanguage(savedLanguage);
      document.documentElement.lang = savedLanguage;
    }
  }, [i18n]);

  useEffect(() => {
    // Initialize smooth scrolling
    initSmoothScroll();

    // Initialize scroll animations
    initScrollAnimations();
  }, []);

  return (
    <Router>
      <MainLayout>
        <AnimatedRoutes />
      </MainLayout>
    </Router>
  );
}

export default App;
